import React from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, Typography } from 'antd';

import { useDocumentTypes } from '../hooks';
import { StyledPanel } from '../styled';
import { DocumentType } from './DocumentType';

export const DocumentTypeList = ({ documentSectionId = '' }) => {
  const { t } = useTranslation();
  const { data, isLoading } = useDocumentTypes(documentSectionId);

  return (
    <>
      {isLoading && <div>{t('Loading')}...</div>}

      <Typography.Title level={4}>{t('Document Types')}</Typography.Title>

      <div style={{ margin: '16px 0' }}>
        <Collapse accordion>
          {data?.map((documentType) => (
            <StyledPanel header={documentType.name} key={documentType.id}>
              <DocumentType sectionProp={documentType} />
            </StyledPanel>
          ))}
        </Collapse>
      </div>
    </>
  );
};
